import _taggedTemplateLiteral from "/home/runner/work/kourikoulom/kourikoulom/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { css } from "@emotion/core";
export default css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    html {\n        box-sizing: border-box;\n    }\n    *,\n    *:before,\n    *:after {\n        box-sizing: inherit;\n    }\n"])));